const TILE_CONFIGS = [
  {
    label: 'offerWizard.stepLargeSolarFacility.dach',
    value: 'dach',
    iconComponent: 'DachIcon',
    urlValue: 'Dach',
  },
  {
    label: 'offerWizard.stepLargeSolarFacility.freiflaeche',
    value: 'freiflaeche',
    iconComponent: 'PVGrossanlageIcon',
    urlValue: 'Freiflaeche',
  },
];

export default TILE_CONFIGS;
